import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, TextField } from '@mui/material';
import DeleteIcon from '../assets/images/deletePopup.svg';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
interface RenewConfirmationDialogProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (data: any) => void;
  page: string;
}

const RenewConfirmationDialog: React.FC<RenewConfirmationDialogProps> = ({
  open,
  handleClose,
  handleConfirm,
  page,
}) => {
  const [startDate, setStartDate] = React.useState<Dayjs | null>();
  const [endDate, setEndDate] = React.useState<Dayjs | null>();
  const [confirmationText, setConfirmationText] = useState('');
  const renewActive = !startDate || !endDate;
  const isDeleteButtonDisabled =
    confirmationText !== page.toUpperCase() && renewActive;

  const formatDtate = (isoDate: any) => {
    const date = new Date(isoDate);

    // Extract the month, day, and year
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const handleSubmitClick = () => {
    if (page === 'Renew') {
      const startDateFormat = formatDtate(startDate);
      const endDateFormat = formatDtate(endDate);

      handleConfirm({ startDate: startDateFormat, endDate: endDateFormat });
    }
    if (page === 'Cancel') {
      setConfirmationText('');
    }
    handleCloseClick();
  };

  const handleCloseClick = () => {
    setStartDate(null);
    setEndDate(null);
    handleClose();
  };

  const shouldDisableEndDate = (date: {
    isAfter: (arg0: any) => any;
    isBefore: (arg0: dayjs.Dayjs) => any;
  }) => {
    if (!startDate) {
      return false; // No startDate selected, so don't disable any dates
    }
    return date.isBefore(startDate);
  };
  const shouldDisableStartDate = (date: {
    isAfter: (arg0: any) => any;
    isBefore: (arg0: dayjs.Dayjs) => any;
  }) => {
    if (!endDate) {
      return false; // No startDate selected, so don't disable any dates
    }
    return date.isAfter(endDate);
  };

  return (
    <Dialog
      className="renew-popup"
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title" className="renew_dialog-heading">
        {page} Plan
      </DialogTitle>
      <DialogContent className="renew_dialog-content">
        <div className="renew_dialog-content-text">
          <div>
            <img src={DeleteIcon} alt={`Delete icon`} width="32" />
          </div>
          Are you sure, you want to <br />
          {page} this Plan?.
        </div>
        {page === 'Renew' ? (
          <div className="renew_dialog-content-date_select">
            <div className="renew_dialog-content-start_date">
              <h4>Start Date</h4>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    value={startDate}
                    onChange={(newValue) => setStartDate(newValue)}
                    shouldDisableDate={shouldDisableStartDate}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>

            <div className="renew_dialog-content-end_date">
              <h4>End Date</h4>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    value={endDate}
                    onChange={(newValue) => setEndDate(newValue)}
                    shouldDisableDate={shouldDisableEndDate}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
          </div>
        ) : page === 'Cancel' ? (
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value)}
            className="delete-input"
            placeholder="Type 'CANCEL' here"
          />
        ) : (
          <></>
        )}
      </DialogContent>
      <DialogActions>
        <div className="renew_dialog-actions">
          <Button
            onClick={handleCloseClick}
            color="primary"
            variant="contained"
            className="renew-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitClick}
            color="primary"
            variant="contained"
            className="renew-active-btn"
            disabled={isDeleteButtonDisabled}
          >
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

const MemoizedComponent = React.memo(RenewConfirmationDialog);
export default MemoizedComponent;
